import { DevService } from './dev.service';
import { DevUtilsModalService } from './dev-utils-modal.service';

export const services = [DevService, DevUtilsModalService];

export * from './dev.service';
export * from './dev-utils-modal.service';
